module.exports = __webpack_public_path__ + "static/media/threads.b735ff16.svg";